let windowLocationHost = window.location.host;

if (windowLocationHost.indexOf('localhost') > -1) {
    __webpack_public_path__ = '/resources/js/dist/';
}
else {
    __webpack_public_path__ = App.publicPath;
}
